<div class="loading" *ngIf="loading">
   <div class="loading-container">
      <ng-lottie [options]="lottieConfig" containerClass="loading__wrapper"></ng-lottie>
   </div>
</div>
